(function Household($, Adzuki)
{
	"use strict";

	var household = {};

	let toggle = false;

	household.confirm = function confirm(response, form_name) {
		var $jForm;

		// this means a confirm dialog needs to be thrown due to a duplicate household address
		if (response.data.response_code === "duplicate") {
			Adzuki.CustomConfirm({
				body   : 'A household with this same address already exists within your franchise\'s database. Do you wish to proceed with saving another household with a duplicated address?',
				confirm: function yes() {
					$jForm = $('form[name="' + form_name + '"]');

					// set hidden input indicating that the user wants to ignore the dupe address, so we do not throw a confirm again
					$jForm.find('.ignore_dupe').val(1);
					$jForm.submit();
				}
			});

		// this means a confirm dialog needs to be thrown due to a connection error with Satori
		} else if (response.data.response_code === "connection_error") {
			Adzuki.AddressVerification.confirmRejected(response, form_name);

		// this is a Satori rejected address with no suggested alternative. User still should be able to force it through
		} else if (response.data.response_code > 100) {
			Adzuki.AddressVerification.confirmRejected(response, form_name);

		// a Satori alternate address suggested.  Need for user to confirm what to do with it
		} else {
			Adzuki.AddressVerification.confirmWithSuggestion(response, form_name);
		}
	};

	$(document).ready(function documentReady()
	{
		$("#zipUpCap").keyup(function getZipUp() {
			$(this).val($(this).val().toUpperCase());
		});

		$('#householdadd-hide_address').on('click', function hideAddresses() {
			var inputs = $('#household-address-box').find('input');
			toggle = !toggle;
			inputs.each(function disableInput() {
				$(this).prop('disabled', toggle);
			});

			$('#household-address-box').toggle();
		});

		Adzuki.onload('Households/index', function onload() {
			var countryId = $('#householdsearch-country_id').val();

			if ((countryId === '183') || (countryId === '31')) {
				$('.state-group').removeClass('hidden');
			}

			$("#household_filter_criteria .remove").click(function removeCriteriaSent(event) {
				removeFilterCriteria($(this));
			});

			$(".household-bulk-update").change(function checkClicked(event) {
				var checked_count   = 0,
				    disabled_status = true;

				// count checked and make sure it's greater than 1.  if it is, enable actions and submit. otherwise disable actions and submit
				$(".household-bulk-update").each(function iti( index, value ) {
					var $element = $(this);

					if ($element.prop('checked')) {
						checked_count++;
					}

					if (checked_count >= 2) {
						return false;
					}
				});

				if (checked_count >= 2) {
					disabled_status = false;
				}

				$('.household-bulk-action').prop('disabled', disabled_status);
				$('.household-bulk-submit').prop('disabled', disabled_status);
			});

			$(".household-bulk-submit").click(function bulkClick(event) {
				// find the select input nearest to the button and use that action
				var $self   = $(this),
				    $parent = $self.parent('.form-group'),
				    action  = $parent.find('.household-bulk-action').val(),
				    $form   = $self.closest('form');

				$('#householdbulk-action').val(action);

				// confirm first
				if (action === 'delete') {
					Adzuki.CustomConfirm({
						body   : 'Are you sure you wish to delete these households?',
						confirm: function confirmSubmit() {
							$form.submit();
						}
					});
				} else {
					$form.submit();
				}
			});
		});

	});

	function removeFilterCriteria($el)
	{
		var filter_key   = $el.data('filter-key'),
		    filter_value = $el.data('filter-value'),
		    url          = Adzuki.base_uri + '/Households/removeFilterCriteria/' + filter_key;

		if (filter_value !== undefined) {
			url += '/' + filter_value;
		}
		window.location.href = url;
	}

	Adzuki.Erez.Household = household;

}(jQuery, window.Adzuki || {}));
